import type { PanZoomState } from '../types';
import { screenToCanvas } from '../types';

export interface ViewportBounds {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

/**
 * Compute the visible canvas-coordinate rectangle from the current
 * pan/zoom state and the container's screen dimensions.
 */
export function getViewportBounds(
  container: HTMLElement,
  panZoom: PanZoomState,
  rotationDeg: number = 0,
): ViewportBounds {
  // Read the container rect once and pass it through to avoid repeated getBoundingClientRect() calls
  const rect = container.getBoundingClientRect();

  const topLeft = screenToCanvas(rect.left, rect.top, container, panZoom, rotationDeg, rect);
  const topRight = screenToCanvas(rect.right, rect.top, container, panZoom, rotationDeg, rect);
  const bottomLeft = screenToCanvas(rect.left, rect.bottom, container, panZoom, rotationDeg, rect);
  const bottomRight = screenToCanvas(rect.right, rect.bottom, container, panZoom, rotationDeg, rect);

  return {
    left: Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x),
    top: Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y),
    right: Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x),
    bottom: Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y),
  };
}
